"use strict";
var r, e;
function a() {
  return e || (e = 1, r = SyntaxError), r;
}
export {
  a as __require
};
//# sourceMappingURL=index.es308.js.map
